import { motion, useReducedMotion } from "framer-motion";
import { SITE } from "../data/site";

// Floating TD shield badge (uses the clean transparent cutout).
export const TDBadge = ({ className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      data-testid="td-bank-badge"
      aria-hidden="true"
      className={`flex flex-col items-center gap-2 ${className}`}
      animate={reduce ? {} : { y: [0, -12, 0], rotate: [-4, 4, -4] }}
      transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut" }}
    >
      <img
        src="/brands/td-shield.png"
        alt=""
        className="h-20 w-20 rounded-2xl object-contain sm:h-24 sm:w-24"
        style={{ filter: "drop-shadow(0 0 34px rgba(52,162,51,0.6)) drop-shadow(0 14px 22px rgba(0,0,0,0.55))" }}
        draggable="false"
      />
      <span className="whitespace-nowrap font-mono text-[9px] uppercase tracking-[0.2em] text-ink/45">
        {SITE.locationCue}
      </span>
    </motion.div>
  );
};

// Inline TD shield for headlines/address lines.
export const TDInline = ({ className = "" }) => (
  <img
    src="/brands/td-shield.png"
    alt="TD Bank"
    data-testid="td-inline-badge"
    className={`inline-block h-[0.85em] w-auto rounded-md align-[-0.1em] shadow-[0_4px_14px_-4px_rgba(0,128,0,0.5)] ${className}`}
    loading="lazy"
    decoding="async"
  />
);
